import React from 'react';

const PortalFooter = ({ role = 'portal' }) => (
  <footer className="bg-slate-950 text-white mt-12 border-t border-white/10">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-7 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div>
        <div className="flex items-center gap-2"><img src="/shopimax-logo.png" alt="SchoolVerse" className="h-7 w-7 rounded-lg object-cover" /><span className="font-black">SchoolVerse</span></div>
        <p className="text-xs text-white/50 mt-2">{role === 'seller' ? 'Seller Portal' : role === 'agent' ? 'Agent Portal' : 'Admin Portal'} · YOUR CAMPUS. YOUR BUSINESS. YOUR WORLD.</p>
      </div>
      <div className="flex flex-wrap gap-x-5 gap-y-2 text-xs text-white/60"><span>Help &amp; Support</span><span>Privacy</span><span>Terms</span><span>© {new Date().getFullYear()} SchoolVerse</span></div>
    </div>
  </footer>
);

export default PortalFooter;
